// Parse number and remove thousands separator (,)
export const parseNumber = (strNumber) => {
    if (typeof strNumber === 'number') {
        return strNumber;
    }
    
    return parseFloat(strNumber.replace(/,/g, ''));
}

export const toFixedWithoutRounding = (value, decimalPlaces = 2) => {
    const pattern = new RegExp(`^-?\\d+(?:\\.\\d{0,${decimalPlaces}})?`);

    return value.toString().match(pattern)[0]
}

const isNumber = (str) => {
    return /^[-+]?\d*\.?\d+$/.test(str);
};

export const parseNumberToStringWithSeparator = (value, decimalPlaces = 0) => {
    if (!isNumber(value)) {
        return value;
    }

    return Number(Number(value).toFixed(decimalPlaces)).toLocaleString(undefined,  { minimumFractionDigits: decimalPlaces })
}

export const formatDecimal = (value, decimalPlaces = 2) => {
    const num = Number(value);

    return num.toFixed(decimalPlaces);
}

export const getDecimalCount = (value) => {
    const decimalIndex = value.toString().indexOf('.');
    return decimalIndex >= 0 ? value.toString().length - decimalIndex - 1 : 0;
}